import { DisplayFees } from 'components/business/offering/DisplayFees';
import { IconInvoice } from '@tock/icons';
import { consumer } from '@tock/coretypes';
import OfferingDetailsMetadataItem from 'components/business/offering/OfferingDetailsMetadataItem';
import React from 'react';

export interface OfferingDetailsFeesProps {
  fees: consumer.IOfferingFee[];
}

export const OfferingDetailsFees: React.FC<OfferingDetailsFeesProps> = ({ fees }) => {
  return (
    <OfferingDetailsMetadataItem icon={IconInvoice} data-testid="fee-details">
      <DisplayFees fees={fees} />
    </OfferingDetailsMetadataItem>
  );
};
